// extracted by mini-css-extract-plugin
export default {"minimap":"lsf-minimap","minimap__region":"lsf-minimap__region","minimap__connection":"lsf-minimap__connection","waiting":"lsf-waiting"};